import * as React from 'react';
import { KnockPropertyConfiguration } from '../../../../../api/PropertyIntegration';
import CollapsibleCard from '../../../../common/CollapsibleCard';
import CheckboxLabeled from '../../../../common/form/CheckboxLabeled';
import FormInput from '../../../../common/form/Input';
import { userIsCompanyManageUser, userIsPropertyManageUser, userIsSystemManageUser } from '../../../../../utilities/identity';

interface Props {
    config?: KnockPropertyConfiguration;
    update: (newConfig?: KnockPropertyConfiguration) => void;
}

const KnockConfigurationSection = (props: Props) => {
    const isUser =
    userIsCompanyManageUser() ||
    userIsPropertyManageUser() ||
    userIsSystemManageUser();
    return(
    <CollapsibleCard
        cardTitle="Knock Configuration"
        cardOpen={!!props.config}
        onCardOpenChange={open =>{
            if (isUser)  return;
            props.update(
                open ? { knockCommunityId: '', useForAvailability: false, unitName: '', companyId: '' } : undefined
            )
        }}
    >
        <div>
            {props.config && (
                <>
                    <FormInput
                        labelProps={{
                            labelText: 'Company ID',
                            invalidText: 'Please enter a Knock Company ID'
                        }}
                        inputProps={{
                            id: 'knock-company-id',
                            name: 'knockCompanyId',
                            value: props.config.companyId,
                            type: 'string',
                            required: true,
                            disabled: isUser
                        }}
                        onChange={(_name, value) =>
                            !isUser && props.update({
                                ...props.config!,
                                companyId: value.toString()
                            })
                        }
                    />
                    <FormInput
                        labelProps={{
                            labelText: 'Community ID',
                            invalidText: 'Please enter a Knock Community ID'
                        }}
                        inputProps={{
                            id: 'knock-community-id',
                            name: 'knockCommunityId',
                            value: props.config.knockCommunityId,
                            type: 'string',
                            required: true,
                            disabled: isUser
                        }}
                        onChange={(_name, value) =>
                            !isUser && props.update({
                                ...props.config!,
                                knockCommunityId: value.toString()
                            })
                        }
                    />
                    <FormInput
                        labelProps={{
                            labelText: 'Unit Name'
                        }}
                        inputProps={{
                            id: 'unit-name',
                            name: 'unitName',
                            value: props.config.unitName,
                            type: 'string',
                            required: false,
                            disabled: isUser
                        }}
                        helpTextProps={{
                            helpText: 'Optional unit name to include with prospects'
                        }}
                        onChange={(_name, value) =>
                            !isUser && props.update({
                                ...props.config!,
                                unitName: value.toString()
                            })
                        }
                    />
                    <CheckboxLabeled
                        labelProps={{
                            labelText:
                                'Use Property Knock Calendar for Tour Scheduling Availability?'
                        }}
                        toggle={true}
                        onChange={() =>
                            !isUser && props.update({
                                ...props.config!,
                                useForAvailability: !props.config!.useForAvailability
                            })
                        }
                        inputProps={{
                            id: 'knock-calendar',
                            name: 'knock-calendar',
                            checked: props.config.useForAvailability,
                            disabled: isUser
                        }}
                    />
                </>
            )}
        </div>
    </CollapsibleCard>
);
};
export default KnockConfigurationSection;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/integrationControls/KnockConfigurationSection.tsx